import { useQuery } from "@tanstack/react-query";
import { usePageContextQuery } from "@/shared/page-context";
import { getCategoryPlaceDataOptions } from "./getCategoryPlaceDataOptions";

export const useCategoryPlaceDataQuery = (gpid: string | number | null | undefined) => {
    const { data } = usePageContextQuery();
    const { locale } = data;

    return useQuery({
        ...getCategoryPlaceDataOptions({ gpid: String(gpid), culture: locale }),
        enabled: !!gpid,
    });
};
